import type { RateProviderUsageTranslations } from "../interfaces/rateProviderUsage";

export const rateProviderUsageTranslations: RateProviderUsageTranslations = {
  // Page
  page_title: "Consumo de proveedores de tasas",
  page_subtitle: "Cuántas peticiones gastamos con cada proveedor de tasas de cambio, mes a mes",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar los contadores de consumo",

  why_heading: "Por qué este contador y no el histórico de tasas",
  why_text:
    "Los proveedores se consultan en orden y el primero que responde gana, dentro de la misma petición. Si el principal falla, gasta su cuota igual pero la tasa que se guarda es la del respaldo. Aquí se cuenta cada petición que sale, responda o no.",

  month_label: "Mes",

  error_load: "No pudimos cargar el consumo",
  error_load_detail: "Vuelve a intentarlo. Si sigue fallando, revisa que el servicio esté disponible.",
  error_retry: "Reintentar",

  // Stat strip
  kpi_month_requests: "Peticiones del mes",
  kpi_month_requests_meta: "Total de {{month}}, sumando todos los proveedores",
  kpi_month_failed: "Fallidas",
  kpi_month_failed_meta: "Gastan cuota igual que las exitosas",
  kpi_primary: "Proveedor principal",
  kpi_primary_none: "Ninguno configurado",
  kpi_primary_meta: "El primero al que se le pregunta",

  // Failover ladder
  ladder_heading: "Orden de consulta",
  ladder_description:
    "De arriba abajo, el orden en que se les pregunta. Cada uno muestra lo que costó y si respondió.",
  ladder_role_primary: "Principal",
  ladder_role_fallback: "Respaldo {{position}}",
  ladder_role_retired: "Fuera del orden",
  ladder_retired_hint: "Gastó cuota en el periodo pero ya no está configurado",
  ladder_never_answered: "No resolvió ninguna tasa",
  ladder_bar_aria: "{{success}} resueltas y {{failed}} fallidas",
  ladder_resolved: "{{value}} resueltas",
  ladder_failed: "{{value}} fallidas",
  ladder_error_unknown: "sin código",
  ladder_no_requests: "Sin peticiones en el periodo",
  ladder_requests_label: "peticiones",

  empty_title: "Sin peticiones registradas",
  empty_description:
    "Ningún proveedor fue consultado en este mes. Si acabas de desplegar, el contador arranca desde ahí.",

  // Month over month
  monthly_heading: "Por mes",
  monthly_description: "Para conciliar contra la factura y ver si el consumo viene subiendo.",
  monthly_column_month: "Mes",
  monthly_column_total: "Total",
  monthly_failed_suffix: "({{value}} fallidas)",
  monthly_empty_cell: "—",
  monthly_empty_title: "Sin historial todavía",
  monthly_empty_description: "Aún no hay meses con peticiones registradas.",

  // Errors
  errors_heading: "Errores del mes",
  errors_description: "Por qué fallaron, para distinguir un despliegue malo de una cuota agotada.",
  errors_none: "Ningún proveedor falló en este mes.",
  errors_http_status: "· HTTP {{status}}",
  errors_detail_message: "Mensaje",
  errors_detail_url: "URL llamada",
  errors_detail_response: "Respuesta del proveedor",
  errors_occurrences: "{{value}} veces",
  errors_last_at: "Último: {{at}}",
};
